import { ApiFragment } from '@digihaven/shared';

import { Series } from '@common/entities/series/series.entity';

export const GetRecordVersion = (record: Series | ApiFragment) => {
    return record instanceof ApiFragment ? record.getVersioningVersion() : record.Version.toString();
};
